import axios from "axios";
import { BASEURL } from "./../helpers/constants";
import { getHistoQueryString } from "./../helpers/histo";
import { tsvParseRows } from "d3-dsv";

const RECEIVE_SENSOR_HISTO_DATA = "RECEIVE_SENSOR_HISTO_DATA";

const requestSensorHisto = (widgetid, device_uid, sensor_uid, begin, end, limit = 5000) => {
    console.log("requestSensorHisto");

    return function (dispatch, getState) {
        // use widgetconfig state to get params like interval
        let widgetConfigState = getState().widgetConfig;
        const qs = getHistoQueryString(widgetConfigState[widgetid]);

        axios
            .get(`${BASEURL}/deviceapi/${device_uid}/sensor/${sensor_uid}/data${qs}`)
            .then(function (response) {
                let data = response.data;
                let parsed = tsvParseRows(data, (data, i) => {
                    return {
                        date: data[0],
                        sensorid: data[1],
                        value: data[2]
                    };
                }).reverse();
                //console.log(parsed)
                dispatch(receiveSensorHistoData(widgetid, device_uid, sensor_uid, parsed));
            })
            .catch(function (error) {
                // handle error
                console.log(error);
            });
    };
};

const receiveSensorHistoData = (widgetid, deviceid, sensorid, data) => ({
    type: RECEIVE_SENSOR_HISTO_DATA,
    widgetid,
    deviceid,
    sensorid,
    data
  });




  
export const actionsTypes = {
    RECEIVE_SENSOR_HISTO_DATA
};

export const actionCreators = {
    requestSensorHisto
};
